/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Create_Password_LabelInputs */

const en_admin_user_create_password_label = /** @type {(inputs: Admin_User_Create_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password (min. 8 chars)`)
};

const de_admin_user_create_password_label = /** @type {(inputs: Admin_User_Create_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort (mindestens 8 Zeichen)`)
};

/**
* | output |
* | --- |
* | "Password (min. 8 chars)" |
*
* @param {Admin_User_Create_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_create_password_label = /** @type {((inputs?: Admin_User_Create_Password_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Create_Password_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_create_password_label(inputs)
	return en_admin_user_create_password_label(inputs)
});